import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { companyResourceType } from "./companyResourceConsts";

export const companyIdentifierStruct = createIdentifierStruct(
  companyResourceType
);
